import { useCompositionQuery } from '@app/modules/compose/hooks/useCompositionQuery';
import { CompositionViewNavigationState } from '@app/modules/compose/routing/compose-route-generator';
import { useLocation, useParams } from 'react-router';

/**
 * Composition detail route: exposes the query and optional list prefetch from navigation state.
 */
export function usePreviewComposition() {
  const { compositionId } = useParams<{ compositionId: string }>();
  const query = useCompositionQuery(compositionId!);
  const location = useLocation<CompositionViewNavigationState | undefined>();
  const compositionFromNavigation = location.state?.composition;

  return {
    query,
    compositionFromNavigation,
    composition: query.data,
  };
}
